import { Controller, Control, Path, FieldValues } from 'react-hook-form'
import { NumberMaterialInput } from '../NumberMaterialInput'

interface NumberInputControllerProps<T extends FieldValues> {
  name: Path<T>
  control: Control<T>
  label: string
  disabled?: boolean
  adornment?: string
  fullWidth?: boolean
  max?: number
  min?: number
  type?: 'currency' | 'percent' | 'integer'
  errorMessage?: string
  maxLength?: number
}

export const NumberInputController = <T extends FieldValues>({
  name,
  control,
  label,
  disabled = false,
  adornment,
  fullWidth = true,
  max,
  min,
  type = 'integer',
  errorMessage,
  maxLength
}: NumberInputControllerProps<T>) => {
  return (
    <Controller<T>
      control={control}
      name={name}
      render={({ field }) => (
        <NumberMaterialInput
          label={label}
          disabled={disabled}
          value={field.value}
          onChange={(value: number | string | undefined) => {
            field.onChange(value)
          }}
          onBlur={field.onBlur}
          name={field.name}
          inputRef={field.ref}
          adornment={adornment ?? ''}
          fullWidth={fullWidth}
          max={max}
          min={min}
          type={type}
          error={!!errorMessage}
          helperText={errorMessage}
          maxLength={maxLength}
        />
      )}
    />
  )
}

export default NumberInputController
